import React from 'react';
import { Lock, Crown } from 'lucide-react';

/** Small "Lumera+" pill shown next to locked Companion features. */
export const LumeraPlusBadge = ({ className = '' }) => (
  <span
    className={`inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200 px-1.5 py-0.5 text-[10px] font-semibold leading-none ${className}`}
    data-testid="lumera-plus-badge"
  >
    <Lock className="w-2.5 h-2.5" />
    Lumera+
  </span>
);

/** Blurred teaser card for the Premium "Go deeper" section. */
export const LockedDeeperTeaser = ({ language, teaser, onUnlock }) => {
  const es = language === 'es';
  return (
    <div className="relative" data-testid="lumera-deeper-locked">
      <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">{teaser}</p>
      <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed blur-[5px] select-none mt-1" aria-hidden="true">
        {es
          ? 'El contexto original, el significado de las palabras clave en hebreo y griego, y cómo lo entendieron los comentaristas históricos.'
          : 'The original context, the meaning of the key Hebrew and Greek words, and how historic commentators understood this passage.'}
      </p>
      <button
        type="button"
        onClick={onUnlock}
        data-testid="lumera-deeper-unlock-btn"
        className="mt-3 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-amber-500 to-amber-700 px-4 py-1.5 text-xs font-semibold text-white shadow hover:from-amber-600 hover:to-amber-800 transition-colors"
      >
        <Crown className="w-3.5 h-3.5" />
        {es ? 'Desbloquear con Lumera+' : 'Unlock with Lumera+'}
      </button>
    </div>
  );
};
